import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import Clarity from '@microsoft/clarity';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Initialize Microsoft Clarity
Clarity.init(environment.clarityProjectId);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
